var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, FieldText, Modal, ModalBody, ModalFoot, ModalHead, } from '@dixa/lib-shared-habla';
import { useCallback, useEffect } from 'react';
import { Field, Form, reduxForm, } from 'redux-form';
import { analytics } from 'app/utils/segment';
import { useDixaMessengerApi } from 'components/settings/components/sections/dixaMessenger/api/apiProvider';
import { useNotifications } from 'hooks/useNotifications';
import { validateName } from 'utils/formValidator';
const MAX_LENGTH = 255;
const NAME_FIELD = 'name';
function RenameModalImpl(props) {
    const notify = useNotifications();
    const messengerApi = useDixaMessengerApi();
    const { messengerId, show, closeModal, refreshItems, handleSubmit, destroy: destroyForm, } = props;
    const handleFormSubmit = useCallback((values) => __awaiter(this, void 0, void 0, function* () {
        const { name } = values;
        analytics.messengerFormSubmitted({ mode: 'rename' });
        try {
            if (!messengerId)
                return;
            yield messengerApi.patch(messengerId, { name });
            notify({
                title: 'Messenger updated',
                text: `Messenger was renamed to "${name}".`,
                icon: 'done',
                className: 'success',
                time: 5000,
            });
            closeModal();
            refreshItems();
        }
        catch (_a) {
            notify({
                title: 'An error occurred',
                text: `An error occurred when trying to update the messenger.`,
                icon: 'exclamation',
                className: 'danger',
            });
        }
    }), [notify, closeModal, refreshItems, messengerId, messengerApi]);
    useEffect(() => {
        if (!show) {
            destroyForm();
        }
    }, [destroyForm, show]);
    return (_jsx(Modal, Object.assign({ isOpen: show, onClose: closeModal }, { children: _jsxs(Box, Object.assign({ width: "600px" }, { children: [_jsx(ModalHead, { title: "Rename messenger", onClose: closeModal }), _jsxs(Form, Object.assign({ onSubmit: handleSubmit(handleFormSubmit) }, { children: [_jsx(ModalBody, { children: _jsx(Field, { label: "Name", name: "name", maxLength: MAX_LENGTH, component: FieldText, type: "text", required: true, validate: validateName }) }), _jsx(ModalFoot, { cancelOnClick: closeModal, confirmName: "Update", confirmOnClick: handleSubmit(handleFormSubmit), confirmProps: { type: 'submit' } })] }))] })) })));
}
export const RenameModal = reduxForm({
    enableReinitialize: true,
    form: 'renameMessengerForm',
    touchOnBlur: false,
})(RenameModalImpl);
